@if (authStore.user()) {
  <div #barrasup class="barrasup">
    <p-menubar [model]="items()" [pt]="{ root: { class: 'menubar-custom' } }" breakpoint="1050px">
      <div class="flex items-center gap-2">
        @if (authStore.user()?.demo) {
          <span
            class="p-tag p-tag-danger p-badge-lg mr-2 cursor-pointer"
            pTooltip=" Actualmente está utilizando el modo DEMOSTRACIÓN. Los certificados obtenidos no tendrán valor. Si desea obtener una
            cuenta NORMAL realice una recarga de crédito."
            (click)="this.router.navigateByUrl('stripe')"
            (keydown.enter)="this.router.navigateByUrl('stripe')"
            tabindex="0"
            tooltipPosition="bottom"
            showDelay="1000"
            >DEMO</span
          >
        }

        <p-button
          type="button"
          [severity]="getThemeButtonSeverity()"
          [rounded]="true"
          variant="outlined"
          (onClick)="cycleTheme()"
          [icon]="getThemeButtonIcon()"
          [pTooltip]="getThemeButtonTooltip()"
          tooltipPosition="bottom"
          [showDelay]="1000"
          [attr.data-theme]="themeStore.userPreference()"
          [styleClass]="
            themeStore.userPreference() === 'light'
              ? 'sun-button'
              : themeStore.userPreference() === 'dark'
                ? 'moon-button'
                : ''
          "
        >
        </p-button>

        <p-button
          type="button"
          severity="warn"
          [rounded]="true"
          variant="outlined"
          class="step_000"
          (click)="btnAyuda()"
          icon="pi pi-compass"
          pTooltip="Pulse aquí si desea realizar un breve tour por las características de la pantalla"
          tooltipPosition="bottom"
          showDelay="1000"
        ></p-button>

        <app-campana></app-campana>

        <svg
          viewBox="0 0 226 63"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="align-middle"
          style="width: auto; height: 30px"
        >
          <path
            d="M28 6 L50 13 L50 33 C50 46 28 57 28 57 C28 57 6 46 6 33 L6 13Z"
            stroke="#2ea3f2"
            stroke-width="2"
            fill="#2ea3f2"
            [attr.fill-opacity]="themeStore.isDarkTheme() ? 0.18 : 0.08"
            stroke-linejoin="round"
          />
          <polyline
            points="16,31 24,42 40,21"
            stroke="#22c55e"
            stroke-width="5"
            stroke-linecap="round"
            stroke-linejoin="round"
            fill="none"
          />
          <text
            x="62"
            y="44"
            font-family="'Plus Jakarta Sans', -apple-system, sans-serif"
            font-weight="800"
            font-size="34"
            [attr.fill]="themeStore.isDarkTheme() ? '#ffffff' : '#0f172a'"
          >
            CertiFirm
          </text>
        </svg>
      </div>

      @if (authStore.loading()) {
        <p-progressBar mode="indeterminate" [style]="{ height: '2px' }"></p-progressBar>
      }
    </p-menubar>
  </div>
}
